import { URLS, interact, $subscriber, cr } from "fire-wind-water";
import { $extras } from "@/../stempcore/src/core/sextra.js";
import { SdeData } from "./data";
import { userModel } from "./user";
import { forkJoin } from "rxjs";
import { applyI18nExtras } from "../utils/i18n-extras";
// import json from "../sktempjson/seminarNew-wap.json"

const sdeModel = {};
if (!sdeModel.modules) {
  sdeModel.modules = [];
}

class SdeModule {
  constructor() {
    this.tenantId = "";
    this.schemaId = "";
    this.instanceId = URLS.getURL("instanceId");
    this.seminarInfo = null;
    this.extrasInfo = null;
    this.pcExtrasInfo = null;
    this.instance = new SdeData();
    window.$sk.template.module(this);
    this.watchExtras();
  }

  module(o) {
    const key = `sk_temp_seminar_info_${new Date().getTime()}`;
    sdeModel.modules.push({
      key,
      model: o,
    });
    this.isLoad(o);
    return {
      unsubscribe() {
        sdeModel.modules = sdeModel.modules.filter((d) => {
          return d.key !== key;
        });
      },
    };
  }

  skExtrasChange(data) {
    cr.each(sdeModel.modules, (d) => {
      if (d.model.skExtrasChange) {
        d.model.skExtrasChange(data);
      }
    });
  }

  skSeminarEnd(data) {
    cr.each(sdeModel.modules, (d) => {
      if (d.model.skSeminarEnd) {
        d.model.skSeminarEnd(data);
      }
    });
  }

  isLoad(o) {
    const _this = o || this;
    if (this.seminarInfo && _this.skSeminarEnd) {
      _this.skSeminarEnd(this.seminarInfo);
    }
    if (this.extrasInfo && _this.skExtrasChange) {
      _this.skExtrasChange(this.extrasInfo);
    }
  }

  seminarLoad() {
    this.skSeminarEnd(this.seminarInfo);
    userModel.user.getCanRegister(this.seminarInfo);
    if (window.location.href.indexOf("wapNew") > -1) {
      //如果是新wap模板 需要获取PC的config 共用
      this.getConfig(URLS.getURL("configId"), this.seminarInfo.topicConfigId);
    } else {
      this.getConfig(URLS.getURL("configId"));
    }

    this.initSharer(this.seminarInfo);
  }

  skUserEnd() {
    window.console.log(window.$sk.template.get());
    const m = window.$sk.template.get();
    this.tenantId = m.common.tenantId;
    this.schemaId = m.common.schemaId;
    this.getSeminar();
  }

  getSeminar() {
    this.instance.getSeminar(this.instanceId).subscribe((res) => {
      this.seminarInfo = res;
      this.initLink();
      this.seminarLoad();
    });
  }

  getConfig(id, wapId) {
    if (wapId) {
      const o = {
        tenantId: this.tenantId,
        configId: id,
      };
      const p = {
        tenantId: this.tenantId,
        configId: wapId,
      };
      forkJoin(
        this.instance.getConfig(o),
        this.instance.getConfig(p)
      ).subscribe((res) => {
        console.log(res);
        res[0].html.push(res[1].html[0]);
        // json.html.push(res[0].html[0]);
        this.pcExtrasInfo = res[1].html[0];
        this.initConfig(res[0].html);
        console.log(res);
      });
    } else {
      const o = {
        tenantId: this.tenantId,
        configId: id,
      };

      this.instance.getConfig(o).subscribe((res) => {
        // this.initConfig(json.html);
        //
        if (!this.fixUrl(res)) {
          return;
        }
        this.initConfig(res.html);
      });
    }
  }

  watchExtras() {
    $subscriber.subscribe("sk-template-config", (o) => {
      if (this.pcExtrasInfo) {
        o.data.push(this.pcExtrasInfo);
      }
      this.initConfig(o.data);
    });
  }

  initLink() {
    if (URLS.getURL("isSetting") != "1" && URLS.getURL("isPreview") != "1") {
      const tc = URLS.getURL("tc");
      if (interact.isMobile) {
        if (window.location.hash.indexOf("/wap") === -1) {
          if (tc) {
            let tcStr = encodeURIComponent("&tc=" + tc);
            let updateUrl = this.seminarInfo.topicWap
              .split("%23")
              .join(tcStr + "%23");
            window.$sk.goto(updateUrl);
          } else {
            window.$sk.goto(this.seminarInfo.topicWap);
          }
        }
      } else {
        if (window.location.hash.indexOf("/pc") === -1) {
          if (tc) {
            window.$sk.goto(
              URLS.updateSearchParam("tc", tc, this.seminarInfo.topic)
            );
          } else {
            window.$sk.goto(this.seminarInfo.topic);
          }
        }
      }
    }
  }

  initConfig(res) {
    this.extrasInfo = applyI18nExtras($extras(res).extras);
    console.log(this.extrasInfo);

    this.skExtrasChange(this.extrasInfo);
    if (this.extrasInfo.themecolor && this.extrasInfo.themecolor.bgcolor) {
      let themeColorClear = "";
      const rgbaAttr = this.extrasInfo.themecolor.bgcolor.match(/[\d.]+/g);
      if (rgbaAttr.length >= 3) {
        let r, g, b;
        r = rgbaAttr[0];
        g = rgbaAttr[1];
        b = rgbaAttr[2];
        themeColorClear = "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
      }

      document.body.style.setProperty(
        "--themeColor",
        this.extrasInfo.themecolor.bgcolor
      );
      document.body.style.setProperty("--themeColorClear", themeColorClear);
    }
  }

  fixUrl(content) {
    // let hash = content.formalUrlLocation.split('#').length>0?('#' + content.formalUrlLocation.split('#')[1]):'';
    // let hashParams = hash.indexOf('?')>-1?('?'+hash.split('?')[1]):'';
    // let url = content.formalUrlAndUsePage + window.location.search + hash + hashParams;
    // window.$sk.goto(url);
    if (
      window.location.href.indexOf("local") > -1 ||
      window.location.href.indexOf("sinobase.cn") > -1
    ) {
      return true;
    } else if (window.location.href.indexOf(content.formalUrl) < 0) {
      const hash =
        content.formalUrlLocation.split("#").length > 0
          ? "#" + content.formalUrlLocation.split("#")[1]
          : "";
      const hashParams = hash.indexOf("?") > -1 ? "?" + hash.split("?")[1] : "";
      const url1 =
        content.formalUrlAndUsePage +
        window.location.search +
        hash +
        hashParams;
      window.$sk.goto(url1);
      return false;
    }
    return true;
  }

  initSharer(data) {
    if (!interact.isWeChat) {
      return;
    }
    window.$swxsdk.initWxSdk(
      { tenantId: data.tenantId },
      window.$sk.config.apiUrl
    );
    window.$swxsdk.on("sharer", {
      title: data.shareTitle || data.title,
      desc: data.shareDesc,
      link: data.topicWap,
      imgUrl: "https:" + data.shareCoverUrl,
    });
    window.$swxsdk.on("sharer_friends", {
      title: data.shareTitle || data.title,
      desc: data.shareDesc,
      link: data.topicWap,
      imgUrl: "https:" + data.shareCoverUrl,
    });
  }
}

if (!sdeModel.seminar) {
  sdeModel.seminar = new SdeModule();
}

export { sdeModel };
